module.exports = __webpack_public_path__ + "static/media/portfolio (12).8f926935.jpg";